import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let SellOrderApiPromise: Promise<AxiosInstance> | null = null;

const getSellOrderApi = async (): Promise<AxiosInstance | null> => {
  if (SellOrderApiPromise) return SellOrderApiPromise;
  SellOrderApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return SellOrderApiPromise;
};

export interface GetSellOrdersProps {
  fecha?: string;
  monto?: number;
  estados?: number[];
  nroCuenta?: string;
  toneladas?: number;
  grano?: number;
  "P.Pagina": number;
  "P.Records"?: number;
}

export const getSellOrders = async (props: GetSellOrdersProps) => {
  const api = await getSellOrderApi();
  if (!api) return;

  const response = await api.get(
    `/OrdenVenta/GetListadoOrdenesVenta?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface GetSellOrderProps {
  id: number;
}

export const getSellOrder = async (props: GetSellOrderProps) => {
  const api = await getSellOrderApi();
  if (!api) return;

  const response = await api.get(
    `/OrdenVenta/GetDetalleOrdenVenta?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface CreateSellOrderProps {
  nroCuentaOrigen: string;
  tipoFijacion: string;
  grano: number;
  cosecha: string;
  toneladas: number;
  monto: number;
  esCanje: boolean;
  mensaje: string;
}

export const createSellOrder = async (props: CreateSellOrderProps) => {
  const api = await getSellOrderApi();
  if (!api) return;

  const response = await api.post(
    `/OrdenVenta/CrearOrdenVenta?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface UpdateSellOrderProps {
  idSolicitud: number;
  mensaje?: string;
  monto?: number;
  estado?: string;
  precioFinal?: number
}

export const updateSellOrder = async (props: UpdateSellOrderProps) => {
      const api = await getSellOrderApi();
  if (!api) return;

  const response = await api.put(
    `/OrdenVenta/EditarOrdenVenta?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
}

export interface GetAvailableHarvestProps {
  cuenta: number
  grano: number
}

export const getAvailableHarvest = async (props: GetAvailableHarvestProps) => {
  const api = await getSellOrderApi();
  if (!api) return;

  const response = await api.get(`/OrdenVenta/CosechasDisponibles?${objectToQueryStringWithArray(props)}`);

  return response.data;
}
